import { Backdrop, CircularProgress } from "@mui/material";
import React, { useState, useEffect } from 'react';

export interface DefaultBackdropProps {
    open: boolean
}

export default function DefaultBackdrop(props: DefaultBackdropProps) {
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: 1301 }}
            open={props.open}
        >
            <CircularProgress color="inherit" />
        </Backdrop>);
}